import { Box, styled } from "@mui/material";
import { IStyledChatHeaderProps } from "./types";

const StyledHeader = styled(Box)<IStyledChatHeaderProps>(({theme})=>({
    padding: theme.spacing(1.5),
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1,
    display: "flex",
    justifyContent: "space-between",
}))

export {StyledHeader}